<script>
  import ApplicationLayout from "../layouts/Application.svelte";
  import Logo from "../components/Logo.svelte";
  import Form from "../components/Form.svelte";
  import LogoText from "../components/LogoText.svelte";
  import { makeApiRequest } from "../utils/ajax";

  let { ...props } = $props();

  let isLogin = $state(true);
  let isSubmitting = $state(false);
  let serverErrors = $state({});

  let fields = $state([
    {
      name: "email",
      label: "Email address",
      type: "email",
      placeholder: "you@example.com",
      required: true,
      autocomplete: "email",
    },
    {
      name: "password",
      label: "Password",
      type: "password",
      placeholder: "Your password",
      required: true,
      autocomplete: "current-password",
    },
  ]);

  $effect(() => {
    const baseFields = [
      {
        name: "email",
        label: "Email address",
        type: "email",
        placeholder: "you@example.com",
        required: true,
        autocomplete: "email",
      },
      {
        name: "password",
        label: "Password",
        type: "password",
        placeholder: isLogin ? "Your password" : "Create a password",
        required: true,
        autocomplete: isLogin ? "current-password" : "new-password",
      },
    ];

    if (!isLogin) {
      fields = [
        {
          name: "name",
          label: "Name",
          type: "text",
          placeholder: "Your full name",
          required: true,
        },
        ...baseFields,
      ];
    } else {
      fields = baseFields;
    }
  });

  const initialData = {
    name: "",
    email: "",
    password: "",
  };

  function toggleAuthMode() {
    isLogin = !isLogin;
    serverErrors = {}; // Reset server errors when toggling mode
  }

  async function handleRegister(formData) {
    let resp = await makeApiRequest("/auth/register", formData);

    if (resp.success) {
      goToDashboard();
    } else {
      serverErrors = resp;
    }
  }

  async function handleLogin(formData) {
    const resp = await makeApiRequest("/auth/login", formData);

    if (resp.success) {
      goToDashboard();
    } else {
      serverErrors = resp;
    }
  }

  async function handleSubmit(formData) {
    isSubmitting = true;

    if (isLogin) {
      await handleLogin(formData);
    } else {
      await handleRegister(formData);
    }

    isSubmitting = false;
  }

  function goToDashboard() {
    window.location.href = "/dashboard";
  }
</script>

<ApplicationLayout {...props}>
  {#snippet content()}
    <div
      class="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-50 to-purple-50 py-12 px-4 sm:px-6 lg:px-8"
    >
      <div class="max-w-md w-full bg-white rounded-xl shadow-lg p-8 space-y-6">
        <div class="text-center">
          <div class="flex justify-center">
            <Logo size="md" color="blue" />
          </div>
          <h1 class="mt-4">
            <LogoText size="md" />
          </h1>
          <p class="mt-4 text-center text-sm text-gray-600">
            {isLogin ? "Don't have an account?" : "Already have an account?"}
            <button
              type="button"
              class="font-medium text-indigo-600 cursor-pointer hover:text-indigo-500 focus:outline-none transition duration-150 ease-in-out"
              onclick={toggleAuthMode}
            >
              {isLogin ? "Register" : "Sign in"}
            </button>
          </p>
        </div>

        <div class="pt-5">
          <Form
            {fields}
            {initialData}
            onSubmit={handleSubmit}
            submitText={isLogin ? "Sign in" : "Create account"}
            processingText={isLogin ? "Signing in..." : "Creating account..."}
            loading={isSubmitting}
            variant="primary"
            size="md"
            {serverErrors}
          />
        </div>
      </div>
    </div>
  {/snippet}
</ApplicationLayout>
